import styled from '@emotion/styled'
import { Dropdown as AntdDropdown, Form, Radio } from 'antd'

export const Container = styled('div')`
  padding: 32px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: white;
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 32px;
`

export const IconSvg = styled('img')`
  width: 24px;
  height: 24px;
  margin-bottom: 6px;
`

export const DownIconSvg = styled('img')`
  width: 8px;
  height: 4px;
`

export const MarkIconSvg = styled('img')`
  width: 25px;
  height: 25px;
  margin-left: 20px;
  padding: 2px;
  border: 1px solid #e5e5e5;
  border-style: dashed;
`

export const Box = styled('div')``

export const Table = styled('table')`
  width: 100%;
  font-size: 14px;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
`

export const Thead = styled('thead')``

export const Tbody = styled('tbody')``

export const Tr = styled('tr')``

export const Td = styled('td')`
  padding: 12px 16px;
  text-align: center;

  border: none;

  &:not(:last-child) {
    border-right: 1px solid #e5e5e5;
  }
  tr:not(:last-child) & {
    border-bottom: 1px solid #e5e5e5;
  }
`

export const HeadTd = styled(Td)`
  width: 33.33%;
  border-bottom: 1px solid #e5e5e5;

  position: relative;
  height: 155px;
`

export const HeadContent = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const FullRowTd = styled(Td)`
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  background-color: #f6f6f6;
  color: #000000;
  border: none;
`

export const HeadTitle = styled('div')`
  font-size: 16px;
  font-weight: 500;
  color: #000000;
`

export const HeadPolicyNumber = styled('div')`
  font-size: 12px;
  font-weight: 400;
  color: #666666;
`

export const HeadPolicyDate = styled('div')`
  font-size: 12px;
  font-weight: 400;
  color: #c2c2c2;
`

export const Information = styled('div')`
  margin-top: 32px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
`
export const Dropdown = styled(AntdDropdown)``

export const DropdownText = styled('div')`
  font-weight: 500;
  font-size: 10px;
  color: #009640;
`

export const DropdownItem = styled('div')`
  display: flex;
  align-items: center;
  padding: 5px;
`

export const DropdownItemPolicyNumber = styled('div')`
  font-weight: 400;
  font-size: 16px;
  color: #000000;
`

export const DropdownItemCover = styled('div')`
  font-weight: 400;
  font-size: 16px;
  color: #666666;
`

export const DropdownItemCoverDetail = styled('div')`
  font-weight: 400;
  font-size: 16px;
  color: #adadad;
`

export const StyledRadioCardGroup = styled(Radio.Group)`
  width: 100%;
`

export const StyledRadioCard = styled(Radio)`
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  .ant-radio {
    position: absolute;
    left: -9999px;
    overflow: hidden;
  }
`

export const StyledRadio = styled(Radio)`
  margin: 5px 0px;
`

export const RadioContent = styled('div')`
  width: 100%;
  height: 100%;
`

export const FormItem = styled(Form.Item)``

export const InformationContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 175px;
`

export const InformationBoxIcon = styled('div')`
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const InformationIconSvg = styled('img')`
  width: 24px;
  height: 24px;
`

export const InformationText = styled('div')`
  font-weight: 500;
  font-size: 16px;
  color: #000000;
`
